module.exports = __webpack_public_path__ + "static/media/29EUNOG2.47a0de25.jpg";